import { render, staticRenderFns } from "./QuoteResult.vue?vue&type=template&id=f2ba38b6&scoped=true&"
import script from "./QuoteResult.vue?vue&type=script&lang=js&"
export * from "./QuoteResult.vue?vue&type=script&lang=js&"
import style0 from "./QuoteResult.vue?vue&type=style&index=0&id=f2ba38b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ba38b6",
  null
  
)

export default component.exports